import { FC } from 'react'
import PageHeader from 'components/PageHeader'
import { Terms, Copyright } from '@wellesley/auth'
import { cn } from '@wellesley/ui'

import ServerInfo from './components/ServerInfo'

import { LoaderSkeleton } from './LoaderSkeleton'
import defaultServerImage from './assets/cover.png'

import { AboutServerSectionProps } from './types'
import { AboutServerTabs } from './components/AboutServerTabs'

export const AboutServerSection: FC<AboutServerSectionProps> = ({
  stats,
  contacts,
  isLoading,
  description,
  serverRules,
  showBlockedDomainsTab,
  showBlockedDomainsReason,
  serverInfoData,
  className,
}) => {
  const imageBanner = serverInfoData.image || defaultServerImage

  if (isLoading) return <LoaderSkeleton />

  return (
    <div
      className={cn(
        'relative mx-auto my-m flex h-screen max-h-[calc(100vh-40px)] w-full max-w-[600px] flex-col overflow-hidden rounded-lg bg-white md:min-w-[760px]',
        className,
      )}
    >
      <div className="flex-shrink-0 p-m">
        <PageHeader>About server</PageHeader>
      </div>
      <div className="no-scrollbar flex flex-1 flex-col overflow-y-auto">
        <div className="mx-m mb-m h-[160px] flex-shrink-0 overflow-hidden rounded-lg bg-gray-100">
          <img
            src={imageBanner}
            alt={`${serverInfoData.name} image`}
            className="cover-image h-full w-full object-cover"
          />
        </div>
        <div className="flex-1">
          <div className="mb-xs px-m">
            <ServerInfo serverInfoData={serverInfoData} />
          </div>
          <AboutServerTabs
            {...{
              stats,
              contacts,
              description,
              serverRules,
              showBlockedDomainsTab,
              showBlockedDomainsReason,
            }}
          />
        </div>
        <div className="mb-xs mt-auto flex flex-shrink-0 items-center justify-between border-t bg-white px-m pt-xxs">
          <Copyright />
          <Terms />
        </div>
      </div>
    </div>
  )
}
